import { render, staticRenderFns } from "./VEllipsis.vue?vue&type=template&id=472fdd1f&"
import script from "./VEllipsis.vue?vue&type=script&lang=ts&"
export * from "./VEllipsis.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('472fdd1f')) {
      api.createRecord('472fdd1f', component.options)
    } else {
      api.reload('472fdd1f', component.options)
    }
    module.hot.accept("./VEllipsis.vue?vue&type=template&id=472fdd1f&", function () {
      api.rerender('472fdd1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VEllipsis/VEllipsis.vue"
export default component.exports